(function () {
    "use strict";

    angular.module("app.location").factory("LocationService", LocationService);

    LocationService.$inject = ["$http", "$q"];

    function LocationService($http, $q) {
        var service = {
            getCountry: getCountry,
            getStateProvince: getStateProvince,
            getCity: getCity,
            getDistrict: getDistrict,
            getWarehouseIds:getWarehouseIds
        };

        var serviceBase = "/";

        return service;

        
        function getCountry() {
            var deferred = $q.defer();

            $http.get(serviceBase + 'panelapi/v1.0/general/country')
                .then(getCountryComplete)
                .catch(getCountryFailed);

            function getCountryComplete(response) {
                deferred.resolve(response.data);
            }

            function getCountryFailed(error) {
                console.error('XHR Failed ' + error);
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getStateProvince(CountryId) {
            var deferred = $q.defer();

            $http.get(serviceBase + 'panelapi/v1.0/general/stateProvince/' + CountryId)
                .then(getStateProvinceComplete)
                .catch(getStateProvinceFailed);

            function getStateProvinceComplete(response) {
                deferred.resolve(response.data);
            }

            function getStateProvinceFailed(error) {
                console.error('XHR Failed ' + error);
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getDistrict(StateProvinceId) {
            var deferred = $q.defer();

            $http.get(serviceBase + 'panelapi/v1.0/general/district/' + StateProvinceId)
                .then(getDistrictComplete)
                .catch(getDistrictFailed);

            function getDistrictComplete(response) {
                deferred.resolve(response.data);
            }

            function getDistrictFailed(error) {
                console.error('XHR Failed ' + error);
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getCity(DistrictId) {
            var deferred = $q.defer();

            $http.get(serviceBase + 'panelapi/v1.0/general/city/' + DistrictId)
                .then(getCityComplete)
                .catch(getCityFailed);

            function getCityComplete(response) {
                deferred.resolve(response.data);
            }

            function getCityFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

        function getWarehouseIds(location){

            var deferred = $q.defer();

            $http
                .get(serviceBase + "api/Warehouse/get", {
                    params: location,
                })
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }

            return deferred.promise;
        }

    }

})();